import {useState} from 'react';

// const map = [
//     [
//         'When does the tournament take place?', 
//         'The tournament runs every week, and prizes are awarded every Thursday.'
//     ],
//     [
//         'How can I join?',
//         'It’s simple:<br/></br><b>1.</b> Make a deposit.<br/><b>2.</b> Play and win in games.<br/><b>3.</b> Climb the leaderboard and claim your prize.'
//     ],
//     [
//         'How are winners determined?',
//         'The more you win on Lucksy games, the higher you rank on the leaderboard.'
//     ],
//     [
//         'What is the prize pool?',
//         'The total prize pool is $1000, shared among the top 15 players of the week.'
//     ],
//     [
//         'Where can I check my position?',
//         'You can track your progress in the leaderboard on the tournament page.'
//     ],
//     [
//         'When will I receive my prize?',
//         'Prizes are credited to the winners right after the tournament ends on Thursday.'
//     ],
//     [
//         'Do I need to pay to participate?',
//         'No, participation is free. All you need to do is play cash sessions and win.'
//     ],
//     [
//         'Do bonus games count towards the tournament?',
//         'No, bonus games do not participate in the tournament. Only real-money wins are counted.'
//     ]
// ]

const map = [
    [
        'When does the Summer tournament take place?',
        'The Summer tournament runs during the seasonal event, with the final draw on October 1 at 12:00 AM (UTC).'
    ],
    [
        'How can I join the tournament?',
        'Top up your balance, play games with a $20 minimum deposit, win, and climb the leaderboard.'
    ],
    [
        'How are winners determined?',
        'The more you win in eligible games, the higher you climb on the leaderboard.'
    ],
    [
        'What is the prize pool?',
        'The total prize pool is $2,500, including leaderboard rewards and Lucky Winner prizes.'
    ],
    [
        'What are Lucky Winners?',
        'Lucky Winners are randomly selected participants who receive cash prizes regardless of ranking.'
    ],
    [
        'Where can I check my position?',
        'You can track your current rank and progress on the tournament leaderboard page.'
    ],
    [
        'When will I receive my rewards?',
        'The prize draw takes place on October 1 at 12:00 AM (UTC), after which all rewards are credited.'
    ],
    [
        'Is there an entry fee?',
        'There is no entry fee. You only need to play games with deposits starting from $20.'
    ],
    [
        'Do bonus or free games count?',
        'No. Only wins from real-money games with qualifying deposits are counted.'
    ]
];


export default () => {
    const [active_question, setActiveQuestion] = useState(null);

    return (
        <div className="faq">
            <div className="title">FAQ</div>

            <div className="faq-items">
                {map.map((a, key) => {
                    return (
                        <div key={key} className={`faq-item  ${active_question === key ? 'active' : ''}`} onClick={e => setActiveQuestion(key === active_question ? null : key)}>
                            <div className="faq-question">
                                <span>{a[0]}</span>

                                <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.71074 8.94998L11.9447 15.47C12.799 16.24 14.1969 16.24 15.0512 15.47L22.2852 8.94999" stroke="#30344F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div className="faq-answer" dangerouslySetInnerHTML={{__html: a[1]}}></div>
                        </div> 
                    )
                })}
            </div>
        </div> 
    )
}